import { Injectable } from '@angular/core';

import { OfficeHomePageErrorHandler } from '../../error-handler/error-handler.service';
import { ErrorId } from '../../error-handler/error-id';
import { CreateLink } from '../models/create-link.model';
import { CreateDocumentService } from '../services/create-document.service';
import { CapabilitiesService } from '../shared-context/capabilities.service';

@Injectable({
    providedIn: 'root'
})
export class CreateMenuService {

    public createLinksPromise: Promise<Array<CreateLink>>;
    public createButtonEnabledPromise: Promise<boolean>;

    constructor(
        private readonly createDocumentService: CreateDocumentService,
        private readonly capabilitiesService: CapabilitiesService,
        private readonly globalErrorHandler: OfficeHomePageErrorHandler
        ) {
            this.init();
        }

    private init() {
        this.createLinksPromise = this.createDocumentService.getCreateLinks();

        this.createButtonEnabledPromise = new Promise(resolve => {
            this.createLinksPromise
                .then(createLinks => {
                    resolve(this.capabilitiesService.capabilities.createDocumentSupported && createLinks.length > 0);
                })
                .catch(error => {
                    this.globalErrorHandler.handleError(error, ErrorId.wmh4W);
                    resolve(false);
                });
        });
    }
}
